import { useCompassParams } from '@/components/flows/CompassFlow/helpers'

export function useIsUnauthenticatedClient() {
  const { token } = useCompassParams()
  return !!token
}
